import $ from 'cash-dom'
import buildShareText from './buildShareText'

export default function shareResult(stars: number, time: number, gameNumber: number): void {
	const shareText = buildShareText({ stars, gameNumber, time })
	const shareData: ShareData = { text: shareText }

	function copyToClipboard() {
		navigator.clipboard
			.writeText(shareText)
			.then(() => {
				const $shareBtn = $('.button--share')
				const originalShareBtnContent = $shareBtn.html()
				$shareBtn.html('Copied!')
				setTimeout(() => {
					$shareBtn.html(originalShareBtnContent)
				}, 1500)
			})
			.catch(reason => {
				alert('Failed to copy your results to clipboard')
				console.error(reason)
			})
	}

	if (window.isSecureContext) {
		// some WebViews expose navigator.share but not navigator.canShare, so
		// detect the first, and also check the second if we can
		const canUseWebShare =
			typeof navigator.share === 'function' && (navigator.canShare?.(shareData) ?? true)

		// prefer the native share sheet on touch devices; the share sheet on
		// desktop is usually pretty unhelpful. matchMedia works on the primary
		// input, so touchscreen laptops driven by a mouse should still return
		// false here as the pointer would be classed as "fine"
		const isTouchscreen = window.matchMedia('(pointer: coarse)').matches

		if (isTouchscreen && canUseWebShare) {
			navigator.share(shareData).catch(error => {
				if (error instanceof Error && error.name === 'AbortError') {
					console.log('Share cancelled')
				} else {
					// some other issue went wrong with the share sheet, lets
					// try to copy to the clipboard instead
					console.error(error)
					copyToClipboard()
				}
			})
		} else {
			// copy to clipboard instead of opening the share sheet
			copyToClipboard()
		}
	} else {
		alert(
			'Failed to share because you’re currently playing One Word Search in an ' +
				'insecure context (http).\n\nPlease use the secure site:\n' +
				'https://puzzlist.com/onewordsearch'
		)
	}
}
